import { FarmMember } from 'src/Elements/Farm/types'
import { FarmParticipantOption } from 'src/Libs/farm/types'

/**
 * return the first character of string in upper case
 */
export const getFirstCharacterInUppercase = (string: string): string => {
  return string.charAt(0).toUpperCase()
}

/**
 * return the owner name to be used in the browser tab
 * (we do not capitalize the firstname or lastname due to complexity in names)
 * john da cena -> J. da cena
 * john  undefined-> john
 * undefined da cena -> da cena
 */
export const getOwnerNameForBrowserTab = (firstname?: string, lastname?: string): string | undefined => {
  if (firstname && lastname) return `${getFirstCharacterInUppercase(firstname)}. ${lastname}`
  if (firstname) return firstname
  if (lastname) return lastname
  return undefined
}

export const getTitleWithOwnerName = (ownerName?: string, storageId?: string): string | undefined => {
  if (ownerName && storageId) {
    return `${ownerName} - SN: ${storageId}`
  } else if (ownerName) {
    return `${ownerName}`
  } else if (storageId) {
    return `SN: ${storageId}`
  }

  return undefined
}

export const getTitleWithoutOwnerName = (isFlowTheme: boolean, storageId?: string): string => {
  const mainTitle = `My ${isFlowTheme ? 'Hager Flow' : 'E3/DC'}`

  if (storageId) {
    return `${mainTitle} - SN: ${storageId}`
  }

  return mainTitle
}

export const getClientsForFarmSelector = (farmMaster: FarmMember | undefined, farmClients: FarmMember[] | undefined): FarmParticipantOption[] => {
  if (!farmMaster || !farmClients) return []

  const farmParticipantOptions = [{ ...farmMaster, isClient: false }, ...(farmClients.map(client => ({ ...client, isClient: true })) || [])]

  return farmParticipantOptions
}
